const trustItems = [
  { icon: "ri-certificate-2-line", value: "CGC1524141", label: "FL Certified GC" },
  { icon: "ri-calendar-check-line", value: "Est. 2011", label: "Year Founded" },
  { icon: "ri-home-5-line", value: "1,000+", label: "Homes Built" },
  { icon: "ri-team-line", value: "In-House", label: "Structural Crews" },
  { icon: "ri-shield-check-line", value: "Dual-Lic.", label: "GC + Plumbing" },
];

export default function TrustBar() {
  return (
    <section className="bg-aegisDark relative z-10">
      {/* Gold top accent line */}
      <div className="w-full h-0.5 bg-gradient-to-r from-transparent via-aegisGold to-transparent opacity-60" />

      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-2 md:grid-cols-5 divide-x divide-white/5">
          {trustItems.map((item) => (
            <div
              key={item.value}
              className="group flex flex-col items-center justify-center text-center py-9 px-5 gap-2 hover:bg-white/3 transition-colors duration-300"
            >
              <div className="w-9 h-9 flex items-center justify-center mb-2 border border-aegisGold/20 group-hover:border-aegisGold/50 transition-colors duration-300">
                <i className={`${item.icon} text-aegisGold text-lg`} />
              </div>
              <span className="font-cormorant font-semibold text-aegisGold text-[1.75rem] leading-none tracking-tight">
                {item.value}
              </span>
              <span className="font-inter text-white/35 text-[0.65rem] tracking-[0.18em] uppercase mt-0.5">
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Gold bottom accent line */}
      <div className="w-full h-0.5 bg-gradient-to-r from-transparent via-aegisGold/30 to-transparent" />
    </section>
  );
}
